import { AlgoliaProductHit } from '@jbhi-fi/apis/src/algolia/types/AlgoliaProductHit';
import PriceTag from '@jbhi-fi/lanyard-ui/components/PriceTag';
import React from 'react';

export const HitPriceTag = ({ hit, className }: { hit: AlgoliaProductHit; className?: string }) => {
  const displayWasPrice = hit.showWasPrice;
  const isCashback = hit.pricing?.displayPriceAfterCashback;

  let ticketPrice = 0;
  let actualPrice = hit.pricing.displayPriceInc;

  if (isCashback) {
    ticketPrice = hit.pricing.displayPriceInc;
    actualPrice = hit.pricing.priceAfterCashback ?? 0;
  } else if (displayWasPrice) {
    ticketPrice = hit.pricing?.wasPrice ?? 0;
  }

  return (
    <PriceTag className={className} variant="small" ticket={ticketPrice} actual={actualPrice} cashback={isCashback} />
  );
};
